import sayHienImg from '@/images/helloen.png';
import sayHizhImg from '@/images/hellozh.png';
import sayHiImg from '@/images/sayhi.gif';

// 移除埋点依赖，保留原有点击行为

import '@vcredit/fe-lib/CapiChatDialog.css';
import { omit } from 'lodash-es';
import { useEffect, useRef, useState } from 'react';
import { useNonPassiveEventListener } from '../../../hooks';
import useSafeBarHeight from '../../../hooks/useStatusBarHeight';
import { handleEnClsName, isEn } from '../../../utils/util';

import style from './index.module.less';

/**
 * @description CapiAppIcon draggable with bottom overlay image
 * @author cursor
 */
/**
 * @description CapiAppIcon component
 * @author cursor
 */

function CapiAppIcon(props: {
  prop: React.ImgHTMLAttributes<HTMLImageElement> | boolean | undefined;
  ApiShowMsg?: string;
  onClick: () => void;
}) {
  const { prop, ApiShowMsg, onClick } = props;

  let bubbleText = ''; // 'Capi幫你貸';
  if (ApiShowMsg) {
    bubbleText = ApiShowMsg;
  }

  const [point, setPoint] = useState<{ x: number; y: number }>();
  const imgRef = useRef<HTMLDivElement | null>(null);
  const [halfIconSize, setHalfIconSize] = useState(0);
  const [moving, setMoving] = useState(false);
  const [dockRight, setDockRight] = useState(true);

  const [safeBorder, setSafeBorder] = useState({
    top: 0,
    left: 0,
    right: window.innerWidth,
    bottom: window.innerHeight,
  });

  const [safeBarHeight] = useSafeBarHeight();
  const [safeBottomHeight] = useSafeBarHeight();

  useEffect(() => {
    setSafeBorder(
      Object.assign(safeBorder, {
        top: safeBarHeight,
        bottom: window.innerHeight - safeBottomHeight,
      })
    );
  }, [safeBarHeight, safeBottomHeight]);

  const onTouchMove = (event: TouchEvent) => {
    setMoving(true);
    setPoint({
      x: event.touches[0].pageX - halfIconSize,
      y: event.touches[0].pageY - halfIconSize,
    });
    event.preventDefault();
    event.stopPropagation();
  };

  const onTouchEnd = () => {
    if (!moving) {
      return;
    }
    setTimeout(() => {
      setMoving(false);
    }, 300);
    let newX = point?.x || 0;
    let newY = point?.y || 0;
    if (newX < safeBorder.left) {
      newX = safeBorder.left;
    }
    if (newX > safeBorder.right) {
      newX = safeBorder.right;
    }
    if (newY < safeBorder.top) {
      newY = safeBorder.top;
    }
    if (newY > safeBorder.bottom) {
      newY = safeBorder.bottom;
    }

    const winHalfWidth = window.innerWidth / 2;
    if (newX + halfIconSize > winHalfWidth) {
      newX = safeBorder.right;
      setDockRight(true);
    } else {
      newX = safeBorder.left;
      setDockRight(false);
    }

    setPoint({
      x: newX || 0,
      y: newY || 0,
    });
  };

  useEffect(() => {
    if (imgRef.current) {
      const computedStyle = window.getComputedStyle(imgRef.current);
      const iconHeight = Number.parseFloat(computedStyle.width);
      setHalfIconSize(iconHeight / 2);
      setSafeBorder(
        Object.assign(safeBorder, {
          right: window.innerWidth - iconHeight,
          bottom: window.innerHeight - iconHeight,
        })
      );
    }
  }, []);

  // 使用自定义 Hook 替换原来的事件监听器代码
  useNonPassiveEventListener(imgRef, [
    {
      type: 'touchmove',
      handler: onTouchMove as EventListener,
    },
    {
      type: 'touchend',
      handler: onTouchEnd,
    },
  ]);

  const onOpenCapiDialog = () => {
    if (!moving) {
      onClick();
    }
  };

  return (
    // 解决小范围移动依旧触发点击事件的问题
    <div onClick={onOpenCapiDialog}>
      <div
        ref={imgRef}
        className={style.whatsapp}
        style={{
          top: point?.y,
          left: point?.x,
        }}
      >
        {bubbleText ? (
          <div
            className={`${handleEnClsName(style.bubble)} ${handleEnClsName(style.bubbleImage)} ${
              dockRight ? style.bubbleRight : style.bubbleLeft
            }`}
          >
            <div className={` ${dockRight ? style.spanbubbleRight : style.spanbubbleLeft}`}>
              {bubbleText}
            </div>
          </div>
        ) : null}
        <img alt="" src={sayHiImg} className={style.mainImg} {...omit(prop, 'className')} />
        {isEn() ? (
          <img alt="" src={sayHienImg} className={style.overlayImg} />
        ) : (
          <img alt="" src={sayHizhImg} className={style.overlayImg} />
        )}
      </div>
    </div>
  );
}
// cursor-en

export default CapiAppIcon;
